import React from 'react';
import { CompositeView, GridView, SimpleView } from '@digital/ui';
import Tabela from './Tabela';

const ClassificacaoServico = () => {
  return (
    <SimpleView>
      <CompositeView>
        <GridView noform>
          <Tabela />
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};
export default ClassificacaoServico;
